'1
<template>
  <div class="ub ub-ver fw">
    <template v-if="dataSource?.records?.length > 0">
      <flow-item
        :isFirst="index == 0"
        :isBottom="index == dataSource?.records?.length - 1"
        v-for="(item, index) in dataSource?.records"
        :key="index"
        :item="item"
      ></flow-item>
    </template>
    <a-empty :image="simpleImage" v-else>
      <template #description>暂无数据</template>
    </a-empty>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, reactive, watch } from "vue";
import { ApprovalFlowLogService } from "./approval-flow-log.service";
import { ApprovalFLowLogPageReq } from "./approval-flow-log.interface";
import { columns } from "./constant";
import { useFlowEmitter } from "@/utils/emitter";
import FlowItem from "./flow-item.vue";
import { Empty } from "ant-design-vue";

export default defineComponent({
  isGlobal: true,
  name: "ApprovalFlowLogTable",
  components: { FlowItem },
  props: {
    value: {
      type: Object,
    },
    bizId: {
      type: String,
      required: true,
    },
    bizType: {
      type: String,
      required: true,
    },
    eventName: {
      type: String,
    },
  },
  wmits: ["refresh"],
  setup(props, { emit }) {
    const { onEvent } = useFlowEmitter();

    const queryRef = reactive(new ApprovalFLowLogPageReq());
    const { data: dataSource, loading, run, refresh } = ApprovalFlowLogService.useGetLogs();

    const search = async () => {
      queryRef.current = 1;
      queryRef.size = 1000;
      queryRef.bizId = props.bizId;
      queryRef.bizType = props.bizType;
      console.log("🚀 ~ index.vue:59 ~ search ~ props.bizId:", props.bizId)
      if(!props.bizId||props.bizId=='undefined'){
        return
      }
      await run(props.bizId, props.bizType);
    };

    const onTableChange = async (pagination) => {
      queryRef.current = pagination.current;
      queryRef.size = pagination.pageSize;
      if(!props.bizId){
        return
      }
      await run(props.bizId, props.bizType);
    };
    onMounted(async () => {
      await search();
      onEvent(async (o) => {
        //只触发组件名称一直的事件，且不是列表审核组件自身发起的
        if (o.eventName === props.eventName && !o.isSelf) {
          console.log("🚀 ~ index.vue:79 ~ setup ~ props.bizId:", props.bizId)
          if(!props.bizId){
            return
          }
          await refresh();
        }
      });
    });

    watch(()=>props.value, (n:any,o) => {
      if(n){
        dataSource.value = n
      }
    });
    return {
      columns,
      dataSource,
      loading,
      run,
      onTableChange,
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    };
  },
});
</script>

<style scoped lang="less"></style>
